import standard from './standard';


export default standard;


export minimal from './minimal';